
import React, { Component } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Container, Select, Row, Col } from 'react-bootstrap';
// Import as a module in your JS
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Typeahead } from 'react-bootstrap-typeahead'; // ES2015

import { Bar } from 'react-chartjs-2';

import Datanauts from './Datanauts'
import CountriesDataChart from './data/CountriesDataChart'
import CitiesDataChart from './data/CitiesDataChart'

class App extends Component {
    state = { dataChart: null, chartMode: null, chartFooter: null, currentCountryName: null }

    componentDidMount() {
        this.setCountryData()
    }

    maxElements = 6

    setCountryData() {
        const countries = Datanauts.getCountries()
        countries.sort((a, b) => {
            return a.name === 'unknowed' ? 1 : (a.members === b.members ?
                (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                :
                b.members - a.members)
        })

        let industries = Datanauts.getIndustries()
        industries.sort((a, b) => {
            return a.name === 'unknowed' ? 1 : (a.members === b.members ?
                (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                :
                b.members - a.members)
        })
        let newIndustries = industries.slice()
        if (industries.length > 9) {
            newIndustries = newIndustries.slice(0, 9)
            newIndustries.push({
                name: 'others', members: industries.slice(9).reduce((accumulator, currentValue) => {
                    return accumulator + currentValue.members
                }, 0)
            })
        }

        const genders = Datanauts.getGenders().map(c => { return { ...c, name: c.attribs.name } })

        const classes = Datanauts.getClasses().map(c => { return { ...c, name: `${c.attribs.name} ${c.attribs.year}` } })
        classes.sort((a, b) => {
            return a.year - b.year
        })

        this.setState({
            dataChart: CountriesDataChart.getChartData(countries, this.maxElements),
            chartMode: 'country',
            details: this.createDetailArea(countries, this.onClickButtonMembers, 'country'),
            chartFooter: 'Datanauts worldwide',
            industries: this.createDefaultArea(newIndustries, 'Industries', true),
            countryCount: countries.length,
            cityCount: Datanauts.getCityCount(),
            memberCount: Datanauts.getMemberCount(),
            genders: this.createDefaultArea(genders, 'Genders'),
            classes: this.createDefaultArea(classes, 'Classes')
        })
    }

    setCityData(idCountry) {
        const cities = Datanauts.getCities(idCountry)
        cities.sort((a, b) => {
            return a.name === 'unknowed' ? 1 : (a.members === b.members ?
                (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                :
                b.members - a.members)
        })

        const industries = Datanauts.getIndustriesByCountry(idCountry)
        industries.sort((a, b) => {
            return a.name === 'unknowed' ? 1 : b.members - a.members
        })

        const genders = Datanauts.getGendersByCountry(idCountry)

        const classes = Datanauts.getClassesByCountry(idCountry).map(c => { return { ...c, name: `${c.attribs.name} ${c.attribs.year}` } })
        classes.sort((a, b) => {
            return a.year - b.year
        })

        this.setState({
            dataChart: CitiesDataChart.getChartData(cities, this.maxElements),
            chartMode: 'city',
            details: this.createDetailArea(cities, this.onClickButtonMembers, 'city'),
            chartFooter: 'Datanauts in ' + Datanauts.getCountries().filter(c => c.id === idCountry)[0].name,
            industries: this.createIndustryArea(industries),
            genders: this.createDefaultArea(genders, 'Genders'),
            classes: this.createDefaultArea(classes, 'Classes')            
        })
    }

    createDetailArea(arr, clickMembers, mode) {
        let memberCount = 0;
        const columns = arr.map(c => {
            memberCount += c.members
            return (
                <Col sm={6} md={6} lg={4}>
                    <div className="input-group mb-3">
                        <input type="text" className="form-control" aria-describedby="basic-addon2"
                            disabled={true}
                            value={c.name}
                        />
                        <div className="input-group-append">
                            <button className="btn btn-outline-secondary" type="button" onClick={() => { clickMembers(mode, c.id) }}>
                                {c.members}
                            </button>
                        </div>
                    </div>
                </Col>
            )
        })
        const footer = (
            <div style={{ textAlign: 'center' }}><p><span className='small'>Total: {memberCount}</span></p></div>
        )
        return (
            <div>
                <h4 style={{ textAlign: 'center' }}>{mode === 'country' ? 'Countries' : 'Cities'}</h4>
                <h6 style={{ textAlign: 'center' }}>(click on the number)</h6>

                <Row>
                    {columns}
                </Row>
                {footer}
                {mode === 'city' && <div style={{ textAlign: 'left' }}>
                    <a href="#" onClick={(e) => { e.preventDefault(); this.setCountryData() }}>back to countries</a>
                </div>}
            </div>
        )
    }

    createIndustryArea(arr) {
        const condensed = arr.slice(0, 9)
        if (arr.length > 9) {
            condensed.push({
                name: 'others', members: arr.slice(9).reduce((accumulator, currentValue) => {
                    return accumulator + currentValue.members
                }, 0)
            })
        }

        const columns = condensed.map(c => {
            return (
                <Col xs={12}>
                    <div className="input-group mb-3">
                        <input type="text" className="form-control warning" aria-describedby="basic-addon2" style={{ backgroundColor: 'rgba(255, 206, 86, 0.2)' }}
                            disabled={true}
                            value={c.name}
                        />
                        <div className="input-group-append">
                            <button className="btn btn-outline-secondary" type="button">
                                {c.members}
                            </button>
                        </div>
                    </div>
                </Col>
            )
        })
        return (
            <div>
                <h4 style={{ textAlign: 'center' }}>Industries</h4>
                <Row>
                    {columns}
                </Row>
            </div>
        )
    }

    createDefaultArea(arr, name, totalHidden) {
        const columns = arr.map(c => {
            return (
                <Col xs={12}>
                    <div className="input-group mb-3">
                        <input type="text" className="form-control warning" aria-describedby="basic-addon2" style={{ backgroundColor: 'rgba(255, 206, 86, 0.2)' }}
                            disabled={true}
                            value={c.name}
                        />
                        <div className="input-group-append">
                            <button className="btn btn-outline-secondary" type="button">
                                {c.members}
                            </button>
                        </div>
                    </div>
                </Col>
            )
        })
        return (
            <div>
                <h4 style={{ textAlign: 'center' }}>{name}</h4>
                <Row>
                    {columns}
                </Row>
                {!totalHidden &&
                    <Row>
                        <Col xs={12}>
                            <input type="text" className="form-control warning" aria-describedby="basic-addon2" style={{ backgroundColor: 'rgba(54, 162, 235, 0.2)', textAlign: 'right' }}
                                disabled={true}
                                value={arr.reduce((accumulator, currentValue) => { return accumulator + currentValue.members }, 0)}
                            />
                        </Col>
                    </Row>
                }

            </div>
        )
    }

    onClickButtonMembers = (mode, id) => {
        if (mode === 'country') {
            this.setCityData(id)
        } else {
            const d = Datanauts.getMembersByCity(id)
            const details = (
                <div>
                    <h2>{d.city.name}</h2>
                    <h4>members: {d.city.members}</h4>
                    {d.members.map(m=><p>{m.name.split(' ')[0]}</p>)}
                    <Button onClick={() => { this.setCityData(d.city.idCountry) }}>Back</Button>
                </div>
            )
            this.setState({
                details,
                industries: null,
                genders: null,
                classes: null
            })
        }
    }

    // handleClick(e, k) {
    //     if (this.state.chartMode === 'country') {
    //         if (!k[0]) return
    //         const idElement = parseInt(k[0]._index)
    //         const country = this.chartCountries[idElement]
    //         if (country)
    //             this.setCityData(country.id)
    //     } else {
    //         this.setCountryData()
    //     }
    // }

    render() {
        return (
            <Container>
                <header>
                    <h1>Searchnauts</h1>
                    <h4>Where are NASA Datanauts from?</h4>
                    <p>{this.state.memberCount} members in {this.state.cityCount} cities and {this.state.countryCount} countries</p>
                </header>
                {this.state.dataChart &&
                    <div>
                        <div>
                            <Bar
                                data={this.state.dataChart}
                                width={100}
                                height={400}
                                options={{
                                    maintainAspectRatio: false,
                                    // events: ['click'],
                                    // onClick: (e, k) => { this.handleClick(e, k) },
                                    scales: {
                                        xAxes: [{
                                            barPercentage: 0.5,
                                            minBarLength: 2,
                                            gridLines: {
                                                offsetGridLines: true
                                            }
                                        }],
                                        yAxes: [{
                                            ticks: {
                                                beginAtZero: true
                                            }
                                        }]
                                    }
                                }}

                            />
                        </div>
                        <div style={{ textAlign: 'center' }}><p><span className='small'>{this.state.chartFooter}</span></p></div>
                        <Row>
                            <Col md={8}>
                                {this.state.details}
                            </Col>
                            <Col md={4}>
                                {this.state.industries}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                {this.state.genders}
                            </Col>
                            <Col>
                                {this.state.classes}
                            </Col>
                        </Row>
                    </div>}
                <footer style={{ textAlign: 'center', margin:'2 0px' }}>
                    my stuff as: <a href="https://nasadatanauts.github.io/alexbelloni/" target="_blank">datanaut</a> | <a href="https://alexandrebelloni.com" target="_blank">developer</a>
                </footer>
            </Container>
        );
    }
}

export default App;
